<template>
  <div class="field">
    <div class="age-input">
      <MaskedInput v-model="date"
                   mask="11 / 11 / 1111"
                   placeholder="Дата / Месяц / Год"
                   :class="['input', {'is-error': validState === false}]"
                   @input="onInput">
      </MaskedInput>
    </div>
    <div v-if="errorBirthDateFormat" class="age-input__error">{{errorBirthDateFormat}}</div>
  </div>
</template>

<script>
  import moment from 'moment';
  import MaskedInput from 'vue-masked-input';

  export default {
    props: ['validState'],
    data() {
      return {
        date: '',
        errorBirthDateFormat: ''
      }
    },
    components: {
      MaskedInput
    },
    methods: {
      onInput(value) {
        const birthDateDay = value.substr(0, 2);
        const birthDateMonth = value.substr(5, 2);
        const birthDateYear = value.substr(-4);

        const parseDate = moment(`${birthDateYear}-${birthDateMonth}-${birthDateDay}`).format('YYYY-MM-DD');

        this.$emit('setDate',parseDate);
        this.validateBirthDate();
      },
      validateBirthDate() {
        const date = this.date;

        const birthDateDay = date.substr(0, 2);
        const birthDateMonth = date.substr(5, 2);
        const birthDateYear = date.substr(-4);

        const currentYear = new Date().getFullYear();

        const parseDate = moment(`${birthDateYear}-${birthDateMonth}-${birthDateDay}`);

        this.errorBirthDateFormat = '';

        if (date.substr(-1) !== '_' && date.substr(-1) !== '') {
          if (!(parseDate.isValid() && birthDateYear <= currentYear) || (birthDateYear < 1900 || birthDateYear > currentYear)) {
            this.errorBirthDateFormat = 'Некорректная дата';
            if (birthDateYear < 1900 || birthDateYear > currentYear) {
              this.errorBirthDateFormat = `Некорректная дата. Допустимое значение 1900 - ${currentYear} гг.`
            }
          }
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  .age-input
    display: flex
    width: 100%

    input
      max-width: 100%

    &__error
      color: red
      margin-top: 8px
      font-size: 13px

</style>
